import BaseModelAPI from '../BaseModelAPI';

export default class PutAwayList extends BaseModelAPI {

	static entity = 'putawaylist'
	static entityName = 'putaway';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
